(function($) {
    if ($('.seo-section').length > 0) {
        console.log('SEO Section loaded');
    }
})(jQuery);
